import React, { createContext, useContext, useEffect, useMemo } from 'react'
import { useAuth } from '../hooks/useAuth'
import { AdminApiService } from '../services/adminApiService'

interface AdminApiContextType {
  apiService: AdminApiService
  isReady: boolean
}

const AdminApiContext = createContext<AdminApiContextType | null>(null)

export const AdminApiProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { userId, isAuthenticated } = useAuth()
  
  const apiService = useMemo(() => new AdminApiService(), [])
  
  useEffect(() => {
    if (userId) {
      apiService.setUserId(userId)
    }
  }, [userId, apiService])
  
  const value = {
    apiService,
    isReady: isAuthenticated && !!userId
  }
  
  return (
    <AdminApiContext.Provider value={value}>
      {children}
    </AdminApiContext.Provider>
  )
}

export const useAdminApi = () => {
  const context = useContext(AdminApiContext)
  if (!context) {
    throw new Error('useAdminApi must be used within AdminApiProvider')
  }
  return context
}